













































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { VForm, LoginForm, DictRequest, DictParam, DictOptions, DictFilter } from '@/types'
import { AxiosError } from 'axios'
import { EPLModule } from '@/store/eplmodule'

@Component({ name: 'Auth' })
export default class Auth extends Vue {
  private interval = 0
  private loginpause = 0
  private showLoginForm = true
  private showLoginAlert = false
  private showPauseAlert = false
  valid = true
  private form: LoginForm = {
    username: '',
    passwd: ''
  }

  @Ref('loginform') loginForm!: VForm

  beforeDestroy (): void {
    clearInterval(this.interval)
  }

  get loading () {
    return EPLModule.loading
  }

  mounted (): void {
    this.interval = setInterval(() => {
      if (this.loginpause === 0) {
        this.showPauseAlert = false
        this.showLoginForm = true
        return (this.loginpause = 0)
      }
      this.loginpause--
    }, 1000)
  }

  private onLoginSubmit (): boolean {
    if (this.form.username === 'loginbynfccardtag') {
      return false
    }
    if (!this.loginForm.validate()) {
      return false
    }
    if (localStorage.lastPath === undefined) localStorage.lastPath = '/'
    EPLModule.fetchUser(this.form)
      .then(() => {
        // получим табельный номер
        if (EPLModule.user.driverid !== '') {
          const tn = {} as DictParam
          tn.idx = EPLModule.DictIdx('Drivers')
          tn.request = {} as DictRequest
          tn.request.options = { page: 1, itemsPerPage: 1 } as DictOptions
          tn.request.filter = []
          const d = {} as DictFilter
          d.field = 'uid'
          d.condition = EPLModule.user.driverid
          d.operator = '='
          d.combine = 'AND'
          tn.request.filter.push(d)
          EPLModule.fetchDictData(tn)
            .then(() => {
              if (EPLModule.dicts[tn.idx].rowsCount > 0) {
                EPLModule.setTabn(EPLModule.dicts[tn.idx].rows[0].tabn)
              }
            })
        }
        this.$router.push(localStorage.lastPath)
      })
      .catch((e: AxiosError) => {
        if (e.response && e.response.status === 401) {
          // не верный пароль
          this.showLoginAlert = true
        } else if (e.response && e.response.status === 429) {
          // превышено число попыток
          this.showLoginForm = false
          this.loginpause = 300
          this.showPauseAlert = true
          this.showLoginAlert = false
        }
      })
    return true
  }

  private onReset (): void {
    this.loginForm.resetValidation()
    this.form.username = ''
    this.form.passwd = ''
  }
}
